import { css } from "styled-components";
import { colors, darkModeColors, fonts } from "../../consts";

export const TimeInputCss = css`
  // datepicker calendar styles
  .react-datepicker {
    color: ${darkModeColors.RAISIN_100_WHITE};
    background-color: ${darkModeColors.WHITE_RAISIN_100};
    transition: color 0.8s ease;

    font-family: ${fonts.PLUS_JAKARTA_SANS};
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;

    border-radius: 16px;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.16);
    border: ${(props) =>
      props?.theme?.darkMode ? `1px solid rgba(110, 110, 116, 0.55)` : "unset"};
    padding: 8px;
    width: 100%;

    display: flex;
    flex-direction: column;
  }

  .react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before {
    top: ${(props) => (props?.theme?.darkMode ? `-1px` : "0")};
    border-bottom: none;
  }

  .react-datepicker-popper {
    width: 100%;
  }

  .react-datepicker__header {
    text-align: center;
    background-color: ${darkModeColors.WHITE_RAISIN_100};
    border-bottom: 0px;
    border-radius: 16px 16px 0 0;
    padding: 0;
    position: relative;
  }

  .react-datepicker__time-container {
    width: 100%;
  }

  .react-datepicker__time-box {
    width: 100% !important;
  }

  .react-datepicker__time-list-item {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    text-align: start;
    height: 40px;
    min-height: 40px;
    max-height: 40px;

    border-radius: 8px;

    width: 100%;

    padding: 0 8px;
    opacity: 1;

    &:hover {
      opacity: 1;

      ${(props) => !props?.selected && "background: rgba(52, 48, 61, 0.1);"};
    }
  }

  .react-datepicker__time-list-item--selected {
    background: ${colors.RAISIN_100} !important;
    color: ${colors.WHITE}!important;
  }
`;
